const types = {
	//Get Template name
	GET_COLUMNS_START: "GET_COLUMNS_START",
	GET_COLUMNS_SUCCESS: "GET_COLUMNS_SUCCESS",
	GET_COLUMNS_ERROR: "GET_COLUMNS_ERROR",
	GET_COLUMNS_RESET: "GET_COLUMNS_RESET",
};

export default types;